module.exports = __webpack_public_path__ + "img/catalonia.7a5f190a.svg";